module.exports = __webpack_public_path__ + "static/img/8.3c6abc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/8.png
// module id = kGX0
// module chunks = 0